/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {Database} from "../APIClient.jsx";
import DisplayIcon from "../components/Icons/DisplayIcon.jsx";
import ElementStatus from "../components/ElementStatus.jsx";
import DeploymentHistory from "../components/Container/DeploymentHistory.jsx";
import DisplayStateHistory from "../components/DisplayStateHistory.jsx";
import Tabs from "../components/Tabs/Tabs.jsx";
import Tab from "../components/Tabs/Tab.jsx";
import ButtonComponent from "../components/BasicInputs/ButtonComponent.jsx";
import {motion} from "motion/react";
import WebPagePreview from "../components/Container/WebPagePreview.jsx";
import BuildLogs from "../components/BuildLogs.jsx";
import PageSettings from "../components/Page/PageSettings.jsx";
import ElementDomains from "../components/ElementDomains.jsx";

class PagePage extends Component {
    constructor() {
        super();
        this.state = {
            pageInfo: {},
            currentTab: 0,
            selectedBuild: ""

        }
    }

    async fetchData() {
        let {pageId} = this.props
        let page = await Database.table("Pages", "app").simpleFilter("indexKey", pageId)
        this.setState({pageInfo: page?.recordset?.[0] ?? {}})
    }

    componentDidMount() {
        this.fetchData()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.pageId !== this.props.pageId) {
            this.fetchData()
        }
    }

    openContainerURL() {
        let {pageInfo} = this.state
        window.open("http://" + pageInfo.domain, '_blank', 'noopener,noreferrer')
    }


    render() {
        let {pageInfo, selectedBuild} = this.state

        return (
            <div>
                <div className={"overflow-hidden rounded-lg relative mb-2 border border-1 "}>

                    <motion.img className="h-32 w-full object-cover lg:h-52 shadow-inner"
                                whileHover={{scale: 1.1, rotate: 1}}
                                transition={{
                                    type: "spring",
                                    stiffness: 450,
                                    damping: 15
                                }}
                                src={`/images/containerImages/${pageInfo?.backgroundURL}.jpg`}
                                alt=""/>

                    <div className="px-4 py-3  bg-white/80 z-10 border-b absolute bottom-0 w-full ">
                        <div className="mx-auto flex items-center justify-between gap-x-8 lg:mx-0 ">
                            <div className="flex items-center gap-x-6">
                                <div
                                    className={"h-12 w-12 flex-none rounded-full ring-1 ring-gray-900/10 flex justify-center items-center bg-white"}>
                                    <DisplayIcon iconName={"BsWindow"} className={"h-7 w-7"}/>


                                </div>

                                <h1>
                                    <div
                                        className=" text-base font-semibold leading-6 text-gray-900">{pageInfo.pageName}</div>
                                    {/*<div className="text-xs leading-6 text-gray-500">{pageInfo.pageName}</div>*/}

                                </h1>
                            </div>
                            <div className="flex items-center gap-x-4 sm:gap-x-6">
                                <ButtonComponent
                                    text={"Open URL"}
                                    iconName={"IoLinkOutline"}
                                    onClick={() => {
                                        return this.openContainerURL()

                                    }}/>

                                <ElementStatus name={"Pages"} elementId={pageInfo.indexKey}/>

                            </div>
                        </div>
                    </div>
                </div>
                <Tabs activeKey={this.state.currentTab}
                      onSelect={(number) => this.setState({currentTab: number})} variant={'default'} isBox>
                    <Tab eventKey={0}
                         iconName={"PiLog"}
                         title={"Logs"}>
                        <div className={"pt-4 flex flex-row gap-2"}>

                            <div className={"w-2/3"}>
                                {selectedBuild === "" ? (<>
                                    <div
                                        className={"border shadow rounded overflow-hidden flex justify-center items-center h-[30rem]"}>
                                        <WebPagePreview URL={"https://" + pageInfo.domain}/>

                                    </div>

                                </>) : (<>
                                    <BuildLogs buildId={selectedBuild}/>

                                </>)}


                            </div>
                            <div className={"w-1/3"}>
                                <DeploymentHistory selectedBuild={selectedBuild} imageId={pageInfo.imageIndexKey}
                                                   onSelect={(newSelectedBuild) => {
                                                       this.setState({selectedBuild: newSelectedBuild})
                                                   }}
                                />

                            </div>
                        </div>

                    </Tab>

                    <Tab eventKey={2}
                         title={"Status"}>
                        <DisplayStateHistory name={"Pages"} elementId={pageInfo.indexKey}/>

                    </Tab>
                    <Tab eventKey={3}
                         iconName={"Domain"}
                         title={"Domains"}>
                        <div className={"p-2 bg-white border border-stone-200 rounded-lg"}>
                            <ElementDomains elementId={pageInfo.indexKey} elementType={"page"}/>
                        </div>
                    </Tab>
                    <Tab eventKey={4}
                         iconName={"PiGearSix"}
                         title={"Settings"}>

                        <PageSettings pageId={pageInfo.indexKey}/>

                    </Tab>

                </Tabs>


            </div>
        );
    }
}

PagePage.propTypes = {};

PagePage.defaultProps = {};


export default PagePage;